var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-tabs"},[_vm._t("default"),_c('span',{ref:"highlight",staticClass:"v-tab-link-highlight init"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }